<template>
    <div class="empty-body">
        <span class="empty-text">{{ $t('components.EmptyComponent.empty_data') }}</span>
    </div>
</template>
<style lang="scss" scoped>
.empty-body {
    display: flex;
    width: 100%;
    flex-grow: 1;
    min-height: 50px;
    align-items: center;
    justify-content: center;

    .empty-text {
        font-size: 16px;
        color: #999;
    }
}
</style>